(function(angular){
	'use strict';

	angular
		.module('formValidationModule')
		.factory('FormValidationFactory', [
			formValidationFactoryFunction
		]);

	function formValidationFactoryFunction() {
		var factory = {
			publishErrorVarsToModel: publishErrorVarsToModel
		};

		function publishErrorVarsToModel(newErrorVars, ngModel) {

			var ngModelIsDefined = ngModel !== null;
			var existingErrorVars = ngModel.errorVars;

			if(ngModelIsDefined) {
				if(existingErrorVars) {
					angular.extend(existingErrorVars, newErrorVars);
				} else {
					ngModel.errorVars = newErrorVars;
				}
			}
		}		

		return factory;
		
	}
})(window.angular);